import React from "react";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import { SingleInputField } from "../../../components";
import { forgotAlpinData } from "../../../assets/lib/login";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";
import { CircularLoader } from "../../../components/widgets/CircularLoader";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#fff",
    color: "#000",
    padding: "20px",
    fontFamily: "Montserrat",
  },
  box: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "12px",
    border: "1px solid #ccc",
    boxShadow: "0 0 15px rgba(0,0,0,0.05)",
    width: "100%",
    maxWidth: "450px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    fontFamily: "Montserrat",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "5px",
    fontFamily: "Montserrat",
  },
  subtitle: {
    fontSize: "16px",
    textAlign: "center",
    color: "#555",
    fontFamily: "Montserrat",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    fontFamily: "Montserrat",
  },
  errorText: {
    color: "red",
    fontSize: "14px",
    marginBottom: "5px",
    fontFamily: "Montserrat",
  },
  link: {
    color: "#007BFF",
    cursor: "pointer",
    textDecoration: "underline",
    fontFamily: "Montserrat",
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    fontFamily: "Montserrat",
  },
});

const Layout = (props) => {
  const {
    submitLoading,
    forgotAlpinState,
    errorFields,
    getForgotAlpinInput,
    handleSubmitForgotAlpin,
    handleOtpSendClick,
    otp,
    isInvalidOtp,
    phoneNoNot10Digit,
    alpinNot4Digit,
    notExistingUser,
  } = props;

  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      {submitLoading && <CircularLoader isPoistionAbsolute zIndex={3} />}

      <div className={classes.box}>
        <h1 className={classes.title}>Reset Your Alpin</h1>
        <p className={classes.subtitle}>Enter your details to reset your Alpin</p>

        <div className={classes.inputContainer}>
          <SingleInputField
            content={forgotAlpinData.phoneNumber}
            value={forgotAlpinState.phoneNumber}
            getInputData={getForgotAlpinInput}
            errorFields={errorFields}
            isEditable={!otp}
          />
          <SingleInputField
            content={forgotAlpinData.newAlpin}
            value={forgotAlpinState.newAlpin}
            getInputData={getForgotAlpinInput}
            errorFields={errorFields}
            isEditable={!otp}
          />
          {!!otp && (
            <SingleInputField
              content={forgotAlpinData.otp}
              value={forgotAlpinState.otp}
              getInputData={getForgotAlpinInput}
              errorFields={errorFields}
            />
          )}
        </div>

        <div className={classes.actions}>
          {phoneNoNot10Digit && <p className={classes.errorText}>Phone number must be 10 digits long.</p>}
          {notExistingUser && <p className={classes.errorText}>This phone number is not registered.</p>}
          {alpinNot4Digit && <p className={classes.errorText}>Secret alpin must be 4 digits long.</p>}
          {isInvalidOtp && (
            <p className={classes.errorText}>
              Invalid OTP!{" "}
              <span className={classes.link} onClick={handleOtpSendClick}>
                Resend
              </span>{" "}
              the OTP.
            </p>
          )}

          {!!otp ? (
            <Button
              variant="contained"
              sx={{ bgcolor: "#000", color: "#fff", fontWeight: "bold", width: "140px", fontFamily: "Montserrat" }}
              onClick={handleSubmitForgotAlpin}
            >
              Submit
            </Button>
          ) : (
            <Button
              variant="contained"
              sx={{ bgcolor: "#000", color: "#fff", fontWeight: "bold", width: "140px", fontFamily: "Montserrat" }}
              onClick={handleOtpSendClick}
            >
              Send OTP
            </Button>
          )}

          <p style={{ fontFamily: "Montserrat" }}>
            Remember your Alpin?{" "}
            <span className={classes.link} onClick={() => navigate(routes.USER_LOGIN)}>
              Login
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Layout;
